export default __webpack_public_path__ + "static/media/crdc.8172592c.png";